import React from 'react';

const WelcomeWidgetEdit = () => (
  <div />
);

export default WelcomeWidgetEdit;
